import React, { FC } from 'react'
import { motion } from 'framer-motion'

interface IMorphingArrowIconProps {
  className?: string
  color?: string
  isHovered?: boolean
}

const MorphingArrowIcon: FC<IMorphingArrowIconProps> = ({
  className = '',
  color = 'currentColor',
  isHovered,
}) => {
  // Arrow to X morphing variants
  // Based on 24x24 viewBox
  const stemVariants = {
    initial: {
      d: 'M 5 12 L 19 12',
      opacity: 1,
      transition: { duration: 0.3 }
    },
    hover: {
      d: 'M 12 12 L 12 12',
      opacity: 0,
      transition: { duration: 0.3 }
    }
  }

  const topWingVariants = {
    initial: {
      d: 'M 5 12 L 12 5',
      transition: { duration: 0.3 }
    },
    hover: {
      d: 'M 6 6 L 18 18',
      transition: { duration: 0.3 }
    }
  }

  const bottomWingVariants = {
    initial: {
      d: 'M 5 12 L 12 19',
      transition: { duration: 0.3 }
    },
    hover: {
      d: 'M 6 18 L 18 6',
      transition: { duration: 0.3 }
    }
  }

  const animationState = isHovered !== undefined ? (isHovered ? 'hover' : 'initial') : undefined

  return (
    <motion.svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      initial="initial"
      animate={animationState}
      whileHover={isHovered === undefined ? 'hover' : undefined}
      className={`w-6 h-6 overflow-visible ${className}`}
    >
      <motion.path
        variants={stemVariants}
        stroke={color || 'currentColor'}
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <motion.path
        variants={topWingVariants}
        stroke={color || 'currentColor'}
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <motion.path
        variants={bottomWingVariants}
        stroke={color || 'currentColor'}
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </motion.svg>
  )
}

export default MorphingArrowIcon
